import { render, staticRenderFns } from "./createGame.vue?vue&type=template&id=1bad8910&scoped=true"
import script from "./createGame.vue?vue&type=script&lang=js"
export * from "./createGame.vue?vue&type=script&lang=js"
import style0 from "./createGame.vue?vue&type=style&index=0&id=1bad8910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bad8910",
  null
  
)

export default component.exports